<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="month" label="Bulan">
                    <model-select
                      id="month"
                      :options="listMonth"
                      v-model="month"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="month === null"
                      class="invalid-feedback-custom"
                    >Bulan harus di isi.</div>
                  </b-form-group>
                </b-col>
                
                <b-col sm="3">
                  <b-form-group label-for="year" label="Tahun">
                    <model-select
                      id="year"
                      :options="listYear"
                      v-model="year"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="year === null"
                      class="invalid-feedback-custom"
                    >Tahun harus di isi.</div>
                  </b-form-group>
                </b-col>
                
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export Data Produk Terjual</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "summary-sold-product",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      listMonth: [
        { value: "01", text: "January" },
        { value: "02", text: "February" },
        { value: "03", text: "March" },
        { value: "04", text: "April" },
        { value: "05", text: "May" },
        { value: "06", text: "June" },
        { value: "07", text: "July" },
        { value: "08", text: "August" },
        { value: "09", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" }
      ],
      showLabelMonth: {
         "01": "January",
         "02": "February",
         "03": "March",
         "04": "April",
         "05": "May",
         "06": "June",
         "07": "July",
         "08": "August",
         "09": "September",
         "10": "October",
         "11": "November",
         "12": "December"
      },
      listCategoryCustomer: [],
      listCompany: [],
      listMitraDC: [],
      others: null,
      month: null,
      year: null,
      listYear: [
        { value: "2019", text: "2019" },
        { value: "2020", text: "2020" },
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" }
      ],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
     
      loading: false,
      category: null,
      myDate: null,
      othersParam: null,
      dateType: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if ( this.month === null || this.year === null ) {
          alert("Filter harus di isi");
        } else {
          this.loading = true;
        
          this.axios({
            url:
              "web/export/spkb/all-spkb-summary/" +
              this.month +
              "/" +
              this.year  ,
            method: "GET",
            responseType: "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.showLabelMonth[this.month]+" "+this.year+".xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
